import React from 'react'
import { PageHeader } from "antd";
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb';
import WaiveListView from '../../components/WaiveListView/WaiveListView';


const WaiveList = () => {
  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Waive List"
          subTitle=""
          extra={[]}
        ></PageHeader>
        <WaiveListView />

      </div>
    </div>
  )
}

export default WaiveList